import axios from "axios";
import AES from "crypto-js/aes";
import { isPositiveNumber, reduce } from "et3-type-guards";

import configuration from "../configuration/keys/index";
import { TI18nInpt } from "../constants/i18n-server-response";
import getCoreLoginStore from "../stores/core/core-login-store";
import getCorePersonalStore from "../stores/core/core-personal-store";
import { StringOrNumber } from "../Types";

export type Et3Error = {
  errorCode: string;
  et3Message: string;
  errorNumber: TI18nInpt;
};

export type Et3ApiPostResponse<T> = {
  data: T | Et3Error;
  status: "OK" | "ERROR";
  et3Error: Et3Error;
};
export const post = async <T>(
  path: string,
  initialData: unknown
): Promise<Et3ApiPostResponse<T>> => {
  try {
    const adminUserId = getCorePersonalStore().user.get().id;

    if (!isPositiveNumber(adminUserId) && path != "core/checkCredentials") {
      return {
        data: {
          errorCode: "et3Error",
          et3Message: `et3 error from post `,
          errorNumber: 0
        },
        status: "ERROR",
        et3Error: {
          errorCode: "WRONG_ADMIN_ID",
          et3Message: "ERROR",
          errorNumber: 0
        }
      };
    }
    let headers: { [key: string]: StringOrNumber } = {
      "Content-Type": "application/json",
      data: AES.encrypt(
        JSON.stringify({
          adminuserid: adminUserId,
          pass: configuration.pass
        }),
        configuration.encryptData
      ).toString()
    };
    let data = {
      data: AES.encrypt(
        JSON.stringify(initialData),
        configuration.encryptData
      ).toString()
    };
    const rawData = await axios.post(`${configuration.API_URL}${path}`, data, {
      withCredentials: true,
      headers
    });

    const serverData = reduce(() => rawData.data, { data: {} });
    const serverDataDefined = reduce(() => serverData.data, { data: {} });
    const serverStatusDefined = reduce(() => serverData.status, "");
    const serverErrorCode = reduce(() => serverData.errorCode, "");
    const errorNumber = reduce(() => serverData.errorNumber, 0);
    if (errorNumber === 3018 || errorNumber === 3017 || errorNumber === 3035) {
      await getCoreLoginStore().signOutHandler();
    }

    return {
      data: serverDataDefined,
      status: serverStatusDefined,
      et3Error: {
        errorCode: serverErrorCode,
        et3Message: "ERROR",
        errorNumber: errorNumber
      }
    };
  } catch (err) {
    return {
      data: {
        errorCode: "et3Error",
        et3Message: `et3 error from post ${err}`,
        errorNumber: 0
      },
      status: "ERROR",
      et3Error: {
        errorCode: "et3Error",
        et3Message: `et3 error from post ${err}`,
        errorNumber: 0
      }
    };
  }
};
